import React from 'react';
import { Box } from '@mui/material';

import FPAdvantage from './FP-advantage';
import { familiplusBoxAdvantages } from './FP-styles';

function FPLstAdvantages(props: {
  advantages: {
    icon: string;
    text: string;
  }[];
}): JSX.Element {
  return (
    <Box sx={familiplusBoxAdvantages}>
      {props.advantages.map((advantage: any, index: number) => (
        <FPAdvantage key={index} advantage={advantage}></FPAdvantage>
      ))}
    </Box>
  );
}

export default FPLstAdvantages;
